import React from 'react';
import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import TrustSection from './components/TrustSection';
import Services from './components/Services';
import Stats from './components/Stats';
import About from './components/About';
import ValueSection from './components/ValueSection';
import Vision from './components/Vision';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import Blogs from './components/Blogs';
import ServicePage from './components/ServicePage';
import BlogPage from './components/BlogPage';
import AboutUs from './components/AboutUs';
import ServicesPageComponent from './components/ServicesPageComponent';
import ContactUsPage from './components/ContactUsPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';
import Checkout from './components/Checkout';

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-900">
      <Hero />
      <TrustSection />
      <Services />
      <Stats />
      <About />
      <ValueSection />
      <Vision />
      <Pricing />
      <Testimonials />
      <Blogs />
    </div>
  );
};

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <AboutUs />;
};

const ServicesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <ServicesPageComponent />;
};

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <ContactUsPage />;
};

const FAQsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen pt-24 pb-12 bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl font-bold text-white mb-8 text-center">Frequently Asked Questions</h1>
        <div className="space-y-4">
          <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-6 shadow-lg shadow-purple-900/30 border border-purple-500/20">
            <h3 className="text-xl font-bold text-white mb-2">
              What services does Invotage offer?
            </h3>
            <p className="text-gray-400">
              We offer a comprehensive suite of digital solutions including web development, mobile app development, custom software, e-commerce platforms, blockchain integration, UI/UX design, 3D animation, cloud infrastructure, digital marketing, and professional copywriting services.
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-6 shadow-lg shadow-purple-900/30 border border-purple-500/20">
            <h3 className="text-xl font-bold text-white mb-2">
              How long does a typical project take?
            </h3>
            <p className="text-gray-400">
              Project timelines vary based on complexity. Simple websites can be delivered in 2-4 weeks, while complex applications may take 3-6 months. We provide detailed timelines during our initial consultation and keep you updated throughout the development process.
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-6 shadow-lg shadow-purple-900/30 border border-purple-500/20">
            <h3 className="text-xl font-bold text-white mb-2">
              Do you provide ongoing support after project completion?
            </h3>
            <p className="text-gray-400">
              Yes! We offer 24/7 support and maintenance packages to ensure your digital solutions continue performing optimally. Our team is always available to address any issues, implement updates, or add new features as your business grows.
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-6 shadow-lg shadow-purple-900/30 border border-purple-500/20">
            <h3 className="text-xl font-bold text-white mb-2">
              What makes Tecfinity LLC different from other agencies?
            </h3>
            <p className="text-gray-400">
              Our commitment to excellence, transparent communication, and results-driven approach set us apart. With a 95% client satisfaction rate, 4.8/5 average rating, and over 300 successful projects, we deliver solutions that truly move the needle for your business.
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-6 shadow-lg shadow-purple-900/30 border border-purple-500/20">
            <h3 className="text-xl font-bold text-white mb-2">
              Can you work with our existing technology stack?
            </h3>
            <p className="text-gray-400">
              Absolutely! Our team has expertise across a wide range of technologies and platforms. We can seamlessly integrate with your existing systems or recommend the best technology stack for your specific needs and goals.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const BlogsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen pt-24 bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <Blogs />
    </div>
  );
};

function App() {
  return (
    <div className="App bg-gray-900">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/faqs" element={<FAQsPage />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          
          {/* Service Pages */}
          <Route path="/web-development" element={<ServicePage />} />
          <Route path="/mobile-app" element={<ServicePage />} />
          <Route path="/software-development" element={<ServicePage />} />
          <Route path="/ecommerce" element={<ServicePage />} />
          <Route path="/blockchain" element={<ServicePage />} />
          <Route path="/ui-ux-design" element={<ServicePage />} />
          <Route path="/3d-animation" element={<ServicePage />} />
          <Route path="/cloud-solutions" element={<ServicePage />} />
          <Route path="/marketing" element={<ServicePage />} />
          <Route path="/copywriting" element={<ServicePage />} />
          
          {/* Blog Pages */}
          <Route path="/blogs/:slug" element={<BlogPage />} />
          
          {/* Legal Pages */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsConditions />} />
          
          {/* Checkout Page */}
          <Route path="/checkout" element={<Checkout />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
